// Generated by CoffeeScript 1.12.6
var sites;

require('angular-resource');

sites = require('goodeggs-sites');

module.exports = __filename;

angular.module(__filename, ['ngResource', require('../../line_item/angular_resource')]).factory('PurchaseOrder', [
  '$resource', 'LineItem', '$http', '$window', function($resource, LineItem, $http, $window) {
    var PurchaseOrder, baseUrl, createPurchaseOrderInstanceMethod;
    baseUrl = (sites.getUrl('ops-purchase-orders-api', $window.settings)) + "/v1/purchase_orders";
    PurchaseOrder = $resource(baseUrl + "/:id", {
      id: '@_id'
    }, {
      update: {
        method: 'PUT'
      },
      save: {
        method: 'POST'
      },
      query: {
        method: 'GET',
        isArray: true
      },
      get: {
        method: 'GET'
      }
    });
    createPurchaseOrderInstanceMethod = function(methodName) {
      return function(requestBody) {
        return $http.post(baseUrl + "/" + this._id + "/" + methodName, requestBody).then(function(response) {
          var ref;
          return {
            purchaseOrder: new PurchaseOrder(response.data.purchaseOrder),
            lineItems: (ref = response.data.lineItems) != null ? ref.map(function(lineItem) {
              return new LineItem(lineItem);
            }) : void 0
          };
        });
      };
    };
    PurchaseOrder.prototype.$submit = createPurchaseOrderInstanceMethod('submit');
    PurchaseOrder.prototype.$confirm = createPurchaseOrderInstanceMethod('confirm');
    PurchaseOrder.prototype.$cancel = createPurchaseOrderInstanceMethod('cancel');
    PurchaseOrder.prototype.$clone = createPurchaseOrderInstanceMethod('clone');
    PurchaseOrder.prototype.$unconfirm = createPurchaseOrderInstanceMethod('unconfirm');
    PurchaseOrder.prototype.$reconfirm = createPurchaseOrderInstanceMethod('reconfirm');
    PurchaseOrder.prototype.$recordVendorArrival = createPurchaseOrderInstanceMethod('record_vendor_arrival');
    return PurchaseOrder;
  }
]);
